import React from 'react';
import PropTypes from 'prop-types';
import { Button as ButtonAntd } from 'antd';
import { childrenPropType } from '@ackee/lucas';

import Button from '../Button';

import * as styles from './Default.styles';

function Default({ children, size, ...props }) {
    return (
        <Button {...{ size, style: styles.buttonDefault }}>
            {({ className }) => (
                <ButtonAntd
                    {...{
                        className,
                        ...props,
                        type: 'default',
                    }}
                >
                    {children}
                </ButtonAntd>
            )}
        </Button>
    );
}

Default.propTypes = {
    children: childrenPropType.isRequired,
    size: PropTypes.string,
};

Default.defaultProps = {
    size: undefined,
};

export default Default;
